import { IMeetingChangeset } from '../abstract-meeting-changeset';
import { IControlMeetingDetailsDTO } from '../../../api/control.dao';
import { MeetingRoomOperatorsEventBody, SyncOperatorDetails } from '../index';
import { IOperatorDetailsDTO } from '../../../api/rooms.dao';

export class OperatorsAddedToTheMeetingRoom extends IMeetingChangeset<MeetingRoomOperatorsEventBody> {
    public applyChangesToMeeting(meeting: Partial<IControlMeetingDetailsDTO>): Partial<IControlMeetingDetailsDTO> {
        this.addOperatorsToMeetingRoom(meeting);
        return meeting;
    }

    public getMeetingRoomId(): number {
        return super.getChangeset().roomId;
    }

    private addOperatorsToMeetingRoom(meeting: Partial<IControlMeetingDetailsDTO>): void {
        const addedOperators = this.syncedOperators.map(this.syncedOperatorToMeetingOperator);
        meeting.room.operators = (meeting.room.operators || []).concat(addedOperators);
    }

    private get syncedOperators(): SyncOperatorDetails[] {
        return super.getChangeset().operators;
    }

    private syncedOperatorToMeetingOperator(operator: SyncOperatorDetails): IOperatorDetailsDTO {
        const { status, role, ..._operator } = operator;
        const operatorDetails = { ..._operator } as IOperatorDetailsDTO;
        operatorDetails.operatorRole = role || null;
        operatorDetails.operatorStatus = status;

        return operatorDetails;
    }
}
